// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import "babel-polyfill"
import Vue from 'vue';
import ElementUI from 'element-ui';
import {Loading} from 'element-ui'
import App from './App.vue';
import store from './store'
import './element-variables.scss';
import router from './router';
import './assets/iconfont/iconfont.css'
import Dialog from '../src/utils/dialog'
import upgrade from './views/upgrade'
require ('./assets/iconfont/iconfont.js')
const {WosSys,jsSHA} = require('./utils/wos-js-sdk-v2_v0');
window.WosSys = WosSys;
window.jsSHA = jsSHA
Vue.config.productionTip = false;
Vue.use(ElementUI);
Vue.use(Dialog);

if(process.env.NODE_ENV === "development"){
  require('@/mock/index.js')
}

let isPC = function () {
  var ua = window.navigator.userAgent.toLocaleLowerCase();
  var isIOS = /iphone|ipad|ipod/.test(ua);
  var isAndroid = /android/.test(ua);
  return !isIOS && !isAndroid
}();

if (!isPC) {
  window.location.replace('https://wenjuan.58.com/m/survey');
} else {
  new Vue({
    el: '#app',
    router,
    store,
    components: { App },
    template: '<App/>',
  });
}
/* eslint-disable no-new */


// const disableLoadingUrls = ['/bsp/search','/survey/cooperation/op','survey/cooperation/list']
// let loadingInstance = null;
// const loadingOptions = {
//   lock: true,
//   text: '拼命加载中',
// };

// // 请求拦截器
// axios.interceptors.request.use(function (config) {
//   console.log('请求拦截器')
//   let url = config.url;
//   if (!(url.indexOf(disableLoadingUrls[0]) > -1 || url.indexOf(disableLoadingUrls[1]) > -1 || url.indexOf(disableLoadingUrls[2]) > -1)) {
//     loadingInstance = Loading.service(loadingOptions);
//   }
//   config.headers['X-Requested-With'] = 'XMLHttpRequest';
//   return config
// }, function (error) {
//   return Promise.reject(error)
// })
// // // 响应拦截器
// axios.interceptors.response.use(function (response) {
//   loadingInstance.close();
//   console.log(response)
//   return response;
// }, function (error) {
//   loadingInstance.close();
//   console.log(error)
//   return Promise.reject(error)
// })




// WEBPACK FOOTER //
// ./src/main.js